export { default as BFooter } from './b-footer.vue'
export { default as BHeader } from './b-header.vue'
